export enum RepoxType {
  REPOX_LINK = "REPOX_LINK",
  REPOX_BITSTREAM = "REPOX_BITSTREAM",
  REPOX_GUIDE = "REPOX_GUIDE",
  REPOX_GEO = "REPOX_GEO",
  REPOX_SURVEY = "REPOX_SURVEY",
  REPOX_STORY = "REPOX_STORY",
}
